/* eslint-disable jsx-a11y/anchor-is-valid */
import { consumirServicioEncirptacion } from 'api';
import BreadcrumcomponentLogo from 'components/BreadCrumbMex/BreadCrumb';
import BreadCrumbPasosV2 from 'components/BreadCrumbMex/BreadCrumbPasosV2';
import Page from 'components/Page';
import {
  ambienteAplicacion,   
  urlEmisionPoliza,
} from 'constants/urls';
import { useNavbarContext } from 'contexts/NavbarContext';
import React, { useEffect, useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import Loading from 'wrappers/Loading';
import { MarineInland } from './constantes/general';
import './styles.scss';
import EditableTable from '../../components/Table/EditableTable'
import CotizacionFooterBarButtons from './componentes/cotizacionFooterBar';
import { ControllerRender } from 'components/InputsMex/inputs';
import { DropDownFilter,TextInput } from 'components/InputsMex/inputs';
import SimpleContainer from 'components/InputsMex/containers/SimpleContainer';
import { SimpleCheckBox } from 'components/InputsMex/SimpleInputs';
import { PASOS_BREADCRUMBS } from 'utils/constants';
import EmisionFooterBarButtons from "components/Polizas/EmisionFooterBarButtons";
import withValidarRecuperar from 'HOC/withValidarRecuperar'

const MarineInlandInfoadicionalEquipos = ({
  history,
  addWarningToast,
  addSuccessToast,
  params: { idCotizacion },
  dataUsuario,
  qParams: { back,idPoliza, codProducto },
  estadoGeneral
}) => {
  const [loading, setLoading] = useState(false);

  const { cliCodigoCore, userIsLoggedIn, correo } = dataUsuario;
  const [catalogo, setCatalogo] = useState({});
  const [validacionPreferente, setValidacionPreferente] = useState(false);
  const [global, setGlobal] = useState(false);
  const [catalogoBeneficiarioPreferente, setCatalogoBeneficiarioPreferente] = useState([]);
  const [checkDeclaracion, setChekcDeclaracion] = useState({});
  const [validacionAnio, setValidacionAnio] = useState({});  
  const [routes, setRoutes] = useState({});

  useNavbarContext(MarineInland.codProducto);

  const methods = useForm({ mode: 'onChange' });
  const { handleSubmit, reset } = methods;

  const solicitarCatalogosEquipos = async () => {
    setLoading(true);
    const solicitudCatalogos = {
      datosCotizador: {
        prodCodigo: MarineInland.codProducto,
        ambiente: ambienteAplicacion,
        cotPasoCodigo: 'recuperarInformacionMaquinaria',
        polCodigo: idPoliza,       
      }
    };
    let resp = await consumirServicioEncirptacion(urlEmisionPoliza, solicitudCatalogos);        
    if(resp?.transaccion && resp?.catalogo){      
      setCatalogo(resp?.catalogo);                       
      onChangeBeneficiarioPreferente(resp?.catalogo?.defaultBeneficiarioPreferente)
      setChekcDeclaracion(resp?.catalogo?.catalogos?.declaracionDatosIngresados)
      setValidacionAnio(resp?.catalogo?.catalogos?.validacionAnio)
      setRoutes(resp?.catalogo?.pasosRedireccionamiento)
      reset({
        ...
        methods.watch(),
        datosMaquinaria:resp?.catalogo?.datosMaquinaria,
        beneficiarioPreferente:resp?.catalogo?.defaultBeneficiarioPreferente,
        beneficiarioPreferenteGlobal:resp?.catalogo?.beneficiarioPreferenteGlobal,
        declaracionDatosIngresados:resp?.catalogo?.catalogos?.declaracionDatosIngresados?.value,
      }) 
      // Carga de catalogos
      console.log('CAT',resp?.catalogo)
      if(resp?.catalogo?.catalogos?.catalogoBeneficiarioPreferente){
        let CatalogobeneficiarioPreferente = resp?.catalogo?.catalogos?.catalogoBeneficiarioPreferente?.map((item) => ({
          ...item,
          label: item.label,
          value:item
        }))        
        setCatalogoBeneficiarioPreferente(CatalogobeneficiarioPreferente)
      }
    }    
    setLoading(false);
    return true
  };
  

  useEffect(() => {
    solicitarCatalogosEquipos()                               
  }, [idCotizacion]);

  const onSubmit = async (data) => {            
    let dataSend= await onRemoverSkipValidation(data) 
    if(dataSend){
      if(estadoGeneral?.polizaPagada?.validacion){
        onRedireccionar(estadoGeneral?.pasosRedireccionamiento)
      }else{
        guardarDataMiddleware(data, 'submit')      
      }      
    }    
  };  
  const onGuardar = () => {      
    if(estadoGeneral?.polizaPagada?.validacion){
      addWarningToast(estadoGeneral?.polizaPagada?.msgError)
    }else{
      let data = methods.watch()                 
      guardarDataMiddleware(data, 'save')
    }      
  }

  const guardarDataMiddleware = async (data, from) => {
    setLoading(true);    
    let guardarDatos=false  
    if(from == 'save')  { guardarDatos=true}
    const Data = {  
      guardarDatos: guardarDatos,
      datosCotizador: {
        ambiente: ambienteAplicacion,
        prodCodigo: codProducto,    
        cotPasoCodigo: 'guardarInformacionMaquinaria',        
      },
      items: {
        polCodigo: idPoliza || '',             
        datosMaquinaria: data.datosMaquinaria || null,   
        declaracionDatosIngresados:data.declaracionDatosIngresados,                   
        beneficiarioPreferente:data.beneficiarioPreferente || null,
        beneficiarioPreferenteGlobal:data.beneficiarioPreferenteGlobal || null
      },      
    };
    console.log('DAT',JSON.stringify(Data))          
    const res = await consumirServicioEncirptacion(urlEmisionPoliza, Data);    
    if (res?.transaccion === true) {      
        if(from != 'submit'){
          onSuccessMsg('Se ha guardado correctamente la información ingresada')
          reset({... data})
        }else{
          const route = routes.find((e) => e.codigo === "infoAdicionalEquipos");          
          return history.push(`${route.goTo}&ramo=${codProducto}`);         
        }            
    } else {
      reset({data})
      try {
        res.errorDescripcion.forEach((msg) =>
          addWarningToast(msg, { autoDismiss: false }),
        );
      } catch (e) {
        addWarningToast(res?.errorDescripcion || 'Error desconocido', {
          autoDismiss: false,
        });
      }
    }
    setLoading(false);    
  };  
  const onRedireccionar = (pasos) => {
    const route = pasos.find(
      (e) => e.codigo === 'infoAdicionalEquipos',
    );
    history.replace(route.goTo);
    history.push(route.goTo);
  };

  const onSuccessMsg = (msg) => {
    addSuccessToast(msg);
  };
  const onSubmitError = () => {
    addWarningToast('Rellene el formulario correctamente');
  };

  const onValidateTableData = (data) => {
    return data?.map((item) => {  
      return  {
        ...item,    
          anio: validarNumber(item,'anio',validacionAnio)?.anio ,
          marca: validarRequired(item,'marca')?.marca ,
          modelo: validarRequired(item,'modelo')?.modelo ,
          serie: validarRequired(item,'serie')?.serie ,
          beneficiario: validarRequired(item,'beneficiario')?.beneficiario ,
      }
    })
  };
  const onClickAtras = () => {
    const route = routes.find((e) => e.codigo === "infoAdicionalEquipos");          
          return history.push(`${route.goBack}`); 
  };

  const validarRequired = (row, name) => {      
    if(row?.[name]?.skipValidation) {
      row[name].hasError = false;
      row[name].errorMessage = null; 
      return row;
    } 
    //--------
    if(name=='beneficiario'){             
      if(validacionPreferente == true){
        if(!row?.[name]){
          row[name] = {}; 
        } else{
          row[name].hasError = false;
          row[name].errorMessage = null; 
        }                  
        return row
      }      
      if(global == true){
        if(!row?.[name]){
          row[name] = {};
        } 
        else{
          row[name].hasError = false;
          row[name].errorMessage = null; 
        }                
        return row
      }
    }
    if(row?.[name]?.value){
      row[name].hasError = false;
      row[name].errorMessage = null;      
      if (!row?.[name]?.value) {
        row[name].hasError = true;
        row[name].errorMessage = "Este campo es obligatorio";
      }
    }else{      
      // row[name].hasError = true;
      // row[name].errorMessage = "Este campo es obligatorio";        
      if(row[name]?.skipValidation == undefined){
        row[name] = {};
        row[name].hasError = false;
        row[name].errorMessage = "";  
        row[name].value= null
        row[name].skipValidation= true
      }else{
        row[name].hasError = true;
        row[name].errorMessage = "Este campo es obligatorio";
      }
      
    }
    
    return row;
  }
  const onRemoverSkipValidation = async (data) => {        
    let newRowsSkip=data?.datosMaquinaria?.map((item) => ({
      ...item,       
      marca: {  
        ... item.marca,    
        skipValidation:false
      }  ,
      modelo:{    
        ... item.modelo,    
        skipValidation:false
      },
      serie:{    
        ... item.serie,    
        skipValidation:false
      },
      anio:{    
        ... item.anio,    
        skipValidation:false
      } ,   
      beneficiario:{
        ... item.beneficiario,    
        skipValidation:validacionPreferente
      }
    }))       
    console.log('newRowsSkip',newRowsSkip) 
    reset({
      ...
      methods.watch(),
      datosMaquinaria:newRowsSkip,
    })   
    let result = await methods.trigger()
    return result
  };
  
  const validarNumber = (row, name, objValidaton) => {      
    if(row?.[name]?.skipValidation) {
      row[name].hasError = false;
      row[name].errorMessage = null; 
      return row;
    } 
    //----     
    if(row?.[name]?.value){
      row[name].hasError = false;
      row[name].errorMessage = null;
      if(isNaN(+row?.[name]?.value))
       {
        row[name].hasError = true;
        row[name].errorMessage = "Solo se debe ingresar números";
      }   
      else{
        //validar rangos
        const min= objValidaton?.min
        const max= objValidaton?.max
        const val=row?.[name]?.value    
        if(val < min || val > max){      
          let msgdefault=objValidaton?.msgError ? objValidaton?.msgError :`El valor ingresado debe ser entre $${objValidaton?.min} y $${objValidaton?.max}`;
          row[name].hasError = true;
          row[name].errorMessage = msgdefault;
        }
      } 
    }else{
      // row[name] = {};
      // row[name].hasError = true;
      // row[name].errorMessage = "Solo se debe ingresar números";
      if(row[name]?.skipValidation == undefined){
        row[name] = {};
        row[name].hasError = false;
        row[name].errorMessage = "";  
        row[name].value= null
        row[name].skipValidation= true
      }else{
        row[name].hasError = true;
        row[name].errorMessage = "Este campo es obligatorio";
      }
    }
    
    return row;
  }

  const onChangeBeneficiarioPreferente= (value)=>{  
    let data = methods.watch()         
    if(value?.value == 'noAplica'){
      setValidacionPreferente(true)            
      setGlobal(false)       
    }
    else if(value?.value == 'global'){          
      setGlobal(true)      
      setValidacionPreferente(false)            
    }    
    else{
      setValidacionPreferente(false)               
      setGlobal(false)           
    }  
    let newdData=onLimpiarBeneficiario(data?.datosMaquinaria)  
    reset({
      ...
      methods.watch(),
      datosMaquinaria:newdData,
    })    
  }
  
  const onLimpiarBeneficiario=(data)=>{             
    let newRows=data?.map((item) => ({
      ...item,
      beneficiario: {
        hasError:false,
        errorMessage:null,
        value:'',
        skipValidation:true
      }      
    }))  
    console.log('newRows',newRows,'global',global)             
    return newRows  
  }

  return (
    <Loading loading={loading}>
      <div className="container-fluid">
        <Page>
          <BreadcrumcomponentLogo
            {...PASOS_BREADCRUMBS[codProducto].breadCrumb}
          />
          <BreadCrumbPasosV2
            {...PASOS_BREADCRUMBS[codProducto]
              .breadCrumbPasos[1, 2, 3, 4]}
          />
          <FormProvider {...methods}>
              <div className='col-12 col-lg-3'>
                  <SimpleContainer
                      label="Beneficiario preferente*"
                      name="beneficiarioPreferente"
                    >
                      <DropDownFilter
                        name="beneficiarioPreferente"
                        optionLabel="label"
                        optionValue="value"
                        options={catalogoBeneficiarioPreferente}                        
                        rules={{ required: 'Este campo es obligatorio' }}
                        onChangeFn={onChangeBeneficiarioPreferente} 
                        stylesDropDown={customStylesDropDown}
                      />
                    </SimpleContainer>
              </div>
              {global &&
                    <div className='col-12 col-lg-6 py-3'>
                        <div className="form-group">
                            <SimpleContainer label="Beneficiario preferente global*" name="beneficiarioPreferenteGlobal">
                            <TextInput
                              inputProps={{
                                name: 'beneficiarioPreferenteGlobal',
                                type: 'string',
                              }}
                              rules={{
                                required: 'Este campo es obligatorio'
                              }}
                            />
                          </SimpleContainer>
                        </div>
                    </div>
              }
              
            <div className='d-flex justify-content-center'>              
              <div className='col-12 col-xl-12'>                 
                <ControllerRender
                  name="datosMaquinaria"
                  defaultValue={[]}
                  rules={{
                    validate: (/**@type {any[]}*/value) => {
                      onValidateTableData(value)
                      const hasError = value.some(item => item.marca?.hasError || item?.modelo?.hasError || item?.serie?.hasError || item?.anio?.hasError || item?.beneficiario?.hasError )
                      if (hasError) {                        
                        return 'Existen errores en la información ingresada para la maquinaria.'                  
                      }
                      return true;
                    }
                  }}
                  render={({ onChange, value }) => {                    
                    return (<EditableTable
                      wsOptions={catalogo?.listadoEquipos}                      
                      rows={onValidateTableData(value)}
                      setRows={onChange}
                      titleTable={'Desglose adicional de los equipos'}
                      infoAdicional={true}
                      validacionesAdicionales={catalogo?.catalogos}
                      bloquearBeneficiario={global}
                    />)
                  }}
                />                
              </div>
            </div>
            <div className='row'>
            <div className='col-12 col-lg-2' ></div>            
            <div className='col-12 col-lg-8 cls-backgroun-cob' >
              <SimpleCheckBox
                  name={`declaracionDatosIngresados`}
                  id={`declaracionDatosIngresados`}
                  label={checkDeclaracion?.label}                                 
                  labelClass={'cl-label-cob mt-0'} 
                  infoAdicionalLabel={checkDeclaracion?.clausulas}  
                  rules={{
                    validate: {
                      checked: (value) => {
                        if (value) {
                          return true;
                        }
                        return 'Este campo es obligatorio';                        
                      },
                    },
                  }}                                                 
                />   
            </div>  
            <div className='col-12 col-lg-2' ></div>

            </div>
                         
          </FormProvider>
          <div className='py-4'>
            <CotizacionFooterBarButtons
              onClickAtras={onClickAtras}
              onClickGuardar={onGuardar}
              onClickContinuar={methods.handleSubmit(onSubmit, onSubmitError)}
              disabledContinue={!methods.watch("declaracionDatosIngresados")}
            />
          </div>
        </Page>
      </div>
    </Loading>
  );
};

export default withValidarRecuperar(MarineInlandInfoadicionalEquipos,MarineInland.codProducto);

const customStylesDropDown = {
  menu: (provided, state) => ({
    ...provided,
    color: state.selectProps.menuColor,
    marginLeft: "-1em",
    fontSize:"18px"
  }),
  placeholder: (provided, state) => ({
    ...provided,
    fontSize: "16px",
    fontWeigth: "bold",
    color: "#6c757d",
  }),
  valueContainer: (provided, state) => ({
    ...provided,
    fontSize: "16px",
    fontWeigth: "bold",
  }),
  control: (styles) => ({
    ...styles,
    border: "none",
    boxShadow: "none"  ,    
  }),  
  singleValue: (styles) => ({
    ...styles,
    fontWeigth: "bold",
    fontSize:"18px"    
  }),
  option: (styles, { data, isDisabled, isFocused, isSelected }) => {
    const color = "#001871";
    return {
      ...styles,
      backgroundColor: isDisabled
        ? null
        : isSelected
          ? data.color
          : isFocused
            ? "#e9ecef"
            : null,
      ":active": {
        ...styles[":active"],
        backgroundColor: !isDisabled && (isSelected ? data.color : color),
        color: "white",        
      },
    };
  },
};